export default {
  validationError: {
    allowedMinTooLarge: 'min > max',
    allowedMaxTooSmall: 'maks. < min.',
    defaultValueExceedAllowed: 'Wartość domyślna przekroczyła dopuszczalny przedział',
  },
};
